import React from "react"

import { TeamLeaveOverlay } from "./TeamLeaveOverlay"
import { useTeamLeaveOverlayModel } from "./model/useTeamLeaveOverlayModel"

export interface TeamLeaveOverlayPayload {
  projectID: string
}

export interface TeamLeaveOverlayConnectorProps {
  payload: TeamLeaveOverlayPayload
}

export const TeamLeaveOverlayConnector = React.memo(
  ({ payload }: TeamLeaveOverlayConnectorProps) => {
    const {
      role,
      isLastAdmin,
      isLastTeamMember,
      wasLastAdmin,
      isUpdatingAdmin,
      hasPendingInvites,
      teamMemberOptions,
      onUpdateAdmin,
      onLeaveTeam,
      onCancel
    } = useTeamLeaveOverlayModel(payload)

    return (
      <TeamLeaveOverlay
        role={role}
        isLastAdmin={isLastAdmin}
        isLastTeamMember={isLastTeamMember}
        isUpdatingAdmin={isUpdatingAdmin}
        wasLastAdmin={wasLastAdmin}
        hasPendingInvites={hasPendingInvites}
        teamMemberOptions={teamMemberOptions}
        onUpdateAdmin={onUpdateAdmin}
        onLeaveTeam={onLeaveTeam}
        onCancel={onCancel}
      />
    )
  }
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    TEAM_LEAVE_OVERLAY: TeamLeaveOverlayPayload
  }
}
